<div class="mobile-hint">
  <div>
    <i class="app-ico-mask app-ico-mask__swipe"></i> Horizontal scroll
  </div>
  <div class="is-btn is-btn__outfill">Okay</div>
</div>